<script lang="ts" setup>
import { useConnectServiceImpl } from '@/services/lnx-connect.service.ts'
import { onMounted } from 'vue'
import MiniView from '@/views/variants/mini/MiniView.vue'
import { useConnectStore } from '@/libs/api/connect/connect.store.ts'
import DefaultView from '@/views/variants/default/DefaultView.vue'

const connectService = useConnectServiceImpl()
const connectStore = useConnectStore()

onMounted(async () => {
  await connectService.init()
})
</script>

<template>
  <MiniView v-if="connectStore.getConnectVariant === 'mini'" />
  <DefaultView v-if="connectStore.getConnectVariant === 'default'" />
</template>
